import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M8 5v14l11-7z"></path>
  </>,
  'PlayArrow',
)
